import React from "react";
import Link from "../Link";
import "./ExpandTFSAButton.css";

const ExpandTFSAButton = () => {

    return (
        <Link href="/investment-tfsa-page">
            <div className="component-11-1 border-1px-athens-gray-2">
                <div className="expand-tfsa-button">
                    <div className="expand-tfsa-button-5">
                        <div className="tfsa-text">
                            <div className="tfsa-text-1 nunito-bold-blue-20px">TFSA</div>
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    );
}
export default ExpandTFSAButton;